import FanciableVehiclesLabel from '../../../../../pages/vip/features/financiable-vehicles-label/financiable-vehicles-label.desktop';

export default FanciableVehiclesLabel;
